import React from 'react';
import NameAndNumber from '../../../types/report/NameAndNumber';
import { ReactComponent as SearchIcon } from '../../Common/BootstrapIcons/search.svg';
import { ReactComponent as ClearIcon } from '../../Common/BootstrapIcons/close.svg';
import CustomIcon from '../BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../BootstrapIcons/Tooltip/IconTooltip';
import './styles.scss';
import { generateKey } from '../../../infrastructure/helpers/react/commonHelper';
import OutsideClickDetector from '../OutsideClickDetector';
import SelectSearch, { SelectSearchOption, SelectedOptionValue } from 'react-select-search';

interface Props {
    onSearch: (options: NameAndNumber[], value: string, searchBy: string) => void;
    onClearClick: () => void;
    onSearchByChange: (value: string) => void;
    searchByOptions: string[];
    getOptions: (searchBy: string) => NameAndNumber[];
    searchByClassName?: string;
    inpuClassName?: string;
}

interface State {
    value: string;
    matchedOptions: NameAndNumber[];
    showMatches: boolean;
    searchBy: string;
}

class SearchByFor extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            value: '',
            matchedOptions: [],
            showMatches: false,
            searchBy: ''
        }

        this.onChange = this.onChange.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.onInputClick = this.onInputClick.bind(this);
        this.onChangeSearchBy = this.onChangeSearchBy.bind(this);
        this.prepareSearchByOptions = this.prepareSearchByOptions.bind(this);
    }

    onChange(e: any) {

        let matchedOptions = this.tryMatch(e.target.value);

        this.setState({ value: e.target.value, matchedOptions, showMatches: matchedOptions.length > 0 });
    }

    tryMatch(value: string): NameAndNumber[] {

        let resultOptions: NameAndNumber[] = [];

        this.props.getOptions(this.state.searchBy).forEach(x => {
            let words = [x.name].concat(x.name.split(' '));

            let match = words.find(x => x.toLowerCase().indexOf(value.toLowerCase()) > -1);

            if (match) {
                resultOptions.push(x);
            }
        });

        return resultOptions;
    }

    onOptionSelected(option: NameAndNumber) {
        this.setState({ value: option.name, showMatches: false }, () => { this.props.onSearch([option], option.name, this.state.searchBy); });
    }

    onSearchClick(value: string) {

        this.setState({ showMatches: false });

        let options = this.tryMatch(value);

        this.props.onSearch(options, value, this.state.searchBy);
    }

    onInputClick(e: React.MouseEvent<HTMLInputElement>) {

        if (this.state.searchBy) {
            let options = this.props.getOptions(this.state.searchBy);

            this.setState({ matchedOptions: options, showMatches: true });
        }
        else {
            e.preventDefault();
        }
    }

    prepareSearchByOptions(): SelectSearchOption[] {

        let options: SelectSearchOption[] = [];

        this.props.searchByOptions.forEach((o) => options.push({ name: o, value: o, text: o } as SelectSearchOption));

        return options;
    }

    onChangeSearchBy(option: SelectedOptionValue | SelectedOptionValue[]) {

        let searchBy = option.toString();

        this.setState({ searchBy, value: '' }, () => this.props.onSearchByChange(searchBy));
    }

    render(): JSX.Element {
        return (
            <OutsideClickDetector
                onClickOuside={() => this.setState({ showMatches: false })}
            >
                <div className='margin-left-10px display-flex width-100-percents'>
                    <div className='display-flex'>
                        <div className='autocomplete'>
                            <div className='width-100-percents' onClick={() => this.setState({ showMatches: false })}>
                                <SelectSearch
                                    value={this.state.searchBy}
                                    options={this.prepareSearchByOptions()}
                                    placeholder={`${!this.state.searchBy ? 'Search By' : ''}`}
                                    onChange={this.onChangeSearchBy}
                                />
                            </div>
                            <div className='input-container'>
                                <input autoComplete='off'
                                    className={`${this.props.inpuClassName || ''} input-field`}
                                    value={this.state.value}
                                    placeholder={`${!this.state.value ? 'Search For' : ''}`}
                                    type='text'
                                    onChange={this.onChange}
                                    onKeyDown={e => e.key === 'Enter' && this.onSearchClick(this.state.value)}
                                    onClick={this.onInputClick}
                                    name='search-for' />
                                {
                                    this.state.showMatches &&
                                    <ul className='results' onMouseLeave={() => this.setState({ showMatches: false })}>
                                        {this.state.matchedOptions.map(x => {
                                            return <li key={generateKey()} onClick={() => this.onOptionSelected(x)}>{x.name}</li>
                                        })
                                        }
                                    </ul>
                                }
                            </div>
                        </div>
                        <button className='custom-icon-button autocomplete-button' onClick={() => this.onSearchClick(this.state.value)}>
                            <CustomIcon icon={SearchIcon} title={iconTooltip.search} />
                        </button>
                        <button className='custom-icon-button autocomplete-button' onClick={() => this.setState({ value: '', searchBy: '', showMatches: false }, () => this.props.onClearClick())}>
                            <CustomIcon icon={ClearIcon} title={iconTooltip.clear} />
                        </button>
                    </div>
                </div>
            </OutsideClickDetector>
        )
    }
}

export default SearchByFor;